import { differenceInCalendarDays } from 'date-fns';
import { migrate } from '@/versioning';
import { required } from './common';
import { uuidv4, dateToYmd, ymdToDate } from '@/util';
export { History } from './history';

export default class Goal {
    constructor(title, startDate, endDate, unitsDue, unitFormat, version = null) {
        this.title = title ?? required('title');
        this.startDate = startDate ?? required('startDate');
        this.endDate = endDate ?? required('endDate');
        this.unitsDue = Number(unitsDue ?? required('unitsDue'));
        this.version = version ?? goalMigrations.length;
        this.unitFormat = unitFormat ?? {};
		
        this.unitsComplete = 0;
        this.key = uuidv4();
        this.archived = false;
    }

    isOverdue(today) {
        return differenceInCalendarDays(ymdToDate(this.endDate), today) < 0;
    }
}

export function isComplete(goal) {
    return goal.unitsComplete >= goal.unitsDue;
}

export function unitsComplete(history) {
    return history.reduce((acc, x) => acc + x.units, 0);
}

export function calculatePace(due, term, isAdjusted) {
    let stride = 1;
    const unitsPerDay = due / term;

    if (unitsPerDay < 1 && unitsPerDay !== 0) 
        stride = 1 / unitsPerDay;
    

    const unitsPerStrideF = unitsPerDay * stride;
    let unitsPerStride = unitsPerStrideF;
    const floorUnits = Math.floor(unitsPerStrideF);
    if (isAdjusted || floorUnits === 0) 
        unitsPerStride = Math.ceil(unitsPerStrideF);
    else 
        unitsPerStride = floorUnits;
    
    return {
        unitsPerDay,
        unitsPerStride,
        unitsPerStrideF,
        stride: Math.floor(stride),
        strideF: stride,
    };
}

export function parseGoal(jObj) {
    migrate('goal', jObj, goalMigrations);

    const goal = new Goal(
        jObj.title,
        jObj.startDate,
        jObj.endDate,
        jObj.unitsDue,
        jObj.unitFormat,
        jObj.version
    );

    goal.unitsComplete = jObj.unitsComplete;
    goal.key = jObj.key;
    goal.archived = jObj.archived;
    return goal;
}

const goalMigrations = [
    function initial(_goal, _version, _meta) {
        //  no actual action required
    },
    function renameDeletedToArchived(goal, _version) {
        goal.archived = goal.deleted;
        delete goal.deleted;
    },
    function convertUnitFormatToLocaleDict(goal, _version) {
        goal.unitFormat = { 'en-US': goal.unitFormat };
    },
    function goalStartAndEndDateAsPlainYMD(goal, _version) {
        goal.startDate = dateToYmd(new Date(goal.startDate));
        goal.endDate = dateToYmd(new Date(goal.endDate));
    },
    function ensureNewValidatorCompliance(goal, _version) {
        goal.title = goal.title.substr(0, 128);
        goal.unitsDue = Math.min(goal.unitsDue ?? 0, 1000000);
        for (const key of Object.keys(goal.unitFormat)) {
            const value = goal.unitFormat[key];
            if (value != null)
                goal.unitFormat[key] = value.substr(0, 1000000);
        }
    },
    function storeHistorySeparately(goal, _version) {
        // history is moved during meta migration
        goal.unitsComplete = unitsComplete(goal.history);
        delete goal.history;
    },
];